(function(){
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var isAr = document.documentElement.lang === 'ar';
  var T = {
    added: isAr ? 'اتضافت للسلة ✓' : 'Added to bag ✓',
    adding: isAr ? 'بنضيف…' : 'Adding…',
    err: isAr ? 'حصلت مشكلة، جرّبي تاني' : 'Something went wrong, try again',
    toastAdded: isAr ? 'اتضافت للسلة' : 'Added to your bag'
  };
  var isCartPage = document.body.classList.contains('nv-tpl-cart');
  var drawer = document.querySelector('[data-nv-drawer]');
  function replay(el, cls){ if (!el) return; cls = cls || 'is-dropping'; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  function particles(){
    document.querySelectorAll('[data-nv-particles]').forEach(function(box){
      var n = parseInt(box.getAttribute('data-nv-particles'), 10) || 14;
      if (window.matchMedia('(max-width: 760px)').matches) n = Math.ceil(n / 2);
      var html = '';
      for (var k = 0; k < n; k++) {
        var size = 12 + (k * 7) % 20;
        var round = k % 2 ? '50% 50% 50% 0' : '50%';
        var color = k % 3 === 0 ? 'var(--bit2)' : 'var(--bit)';
        html += '<span class="nv-particle" style="left:' + ((k * 61 + 7) % 100) + '%;width:' + size + 'px;height:' + size + 'px;border-radius:' + round + ';background:' + color + ';animation-duration:' + (7 + (k * 3) % 7) + 's;animation-delay:' + (-((k * 1.7) % 9)).toFixed(1) + 's"></span>';
      }
      box.innerHTML = html;
    });
  }
  function puffs(){
    document.querySelectorAll('[data-nv-mist]').forEach(function(box){
      var html = '';
      for (var m = 0; m < 10; m++) {
        html += '<span class="nv-puff" style="--dx:' + (-140 + (m * 37) % 120) + 'px;--dy:' + (-90 + (m * 23) % 140) + 'px;animation-delay:' + (m * 0.24).toFixed(2) + 's"></span>';
      }
      box.innerHTML = html;
    });
  }
  function setVars(target, vars){
    String(vars || '').split(';').forEach(function(pair){
      var i = pair.indexOf(':'); if (i < 1) return;
      target.style.setProperty(pair.slice(0, i).trim(), pair.slice(i + 1).trim());
    });
  }
  function bdi(text){ var b = document.createElement('bdi'); b.textContent = text; return b; }
  function hero(){
    document.querySelectorAll('[data-nv-hero]').forEach(function(sec){
      var dataEl = sec.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var worlds; try { worlds = JSON.parse(dataEl.textContent); } catch(e) { return; }
      var stage = sec.querySelector('[data-nv-stage]');
      var tabs = sec.querySelectorAll('[data-nv-world]');
      function q(s){ return sec.querySelector(s); }
      function setImg(img, src, alt){
        if (!img) return;
        var side = img.closest('[data-nv-side]');
        if (src) { img.src = src; img.alt = alt || ''; if (side) side.hidden = false; }
        else if (side) { side.hidden = true; }
      }
      function show(i, animate){
        var w = worlds[i]; if (!w) return;
        setVars(document.body, w.vars);
        tabs.forEach(function(t, idx){ t.setAttribute('aria-selected', idx === i ? 'true' : 'false'); t.tabIndex = idx === i ? 0 : -1; });
        q('[data-nv-num]').textContent = '0' + (i + 1);
        q('[data-nv-name]').textContent = w.name;
        q('[data-nv-copy]').textContent = w.copy;
        var cta = q('[data-nv-cta]'); cta.href = w.url;
        var lab = q('[data-nv-cta-label]');
        lab.textContent = (cta.getAttribute('data-prefix') || '') + ' ';
        lab.appendChild(bdi(w.name));
        if (w.price) { lab.appendChild(document.createTextNode(' · ')); lab.appendChild(bdi(w.price)); }
        setImg(q('[data-nv-img-main]'), w.img, w.alt);
        setImg(q('[data-nv-img-l]'), w.img2, w.alt2);
        setImg(q('[data-nv-img-r]'), w.img3, w.alt3);
        if (animate) { replay(stage); sec.querySelectorAll('[data-nv-swap]').forEach(function(el){ replay(el, 'nv-swap'); }); }
      }
      tabs.forEach(function(t, idx){
        t.addEventListener('click', function(){ show(idx, true); });
        t.addEventListener('keydown', function(e){
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (isAr) d = -d;
          if (!d) return;
          e.preventDefault();
          var n = (idx + d + tabs.length) % tabs.length; tabs[n].focus(); show(n, true);
        });
      });
      show(0, false);
      replay(stage);
    });
  }
  function updateCount(count){
    document.querySelectorAll('[data-nv-count]').forEach(function(el){ el.textContent = count; el.hidden = count < 1; replay(el, 'is-bump'); });
  }
  function refreshCount(){ return fetch(root + 'cart.js').then(function(r){ return r.json(); }).then(function(c){ updateCount(c.item_count); return c; }); }
  var toastTimer;
  function toast(msg){
    var t = document.querySelector('[data-nv-toast]'); if (!t) return;
    t.querySelector('[data-nv-toast-msg]').textContent = msg;
    t.classList.add('is-on'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('is-on'); }, 3200);
  }
  var lastFocus = null;
  function openDrawer(){
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-nv-drawer-close]'); if (c) setTimeout(function(){ c.focus(); }, 60);
  }
  function closeDrawer(){
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refreshDrawer(){
    if (!drawer) return Promise.resolve();
    return fetch(root + '?sections=nv-cart-drawer').then(function(r){ return r.json(); }).then(function(j){
      var html = j && j['nv-cart-drawer']; if (!html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var nc = tmp.querySelector('[data-nv-drawer-content]'); var oc = drawer.querySelector('[data-nv-drawer-content]');
      if (nc && oc) oc.replaceWith(nc);
    });
  }
  function afterAdd(){
    refreshCount();
    if (isCartPage) { window.location.reload(); return; }
    if (drawer) { refreshDrawer().then(openDrawer); } else { toast(T.toastAdded); }
  }
  function addItems(items){
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || T.err); }); return r.json(); });
  }
  function forms(){
    document.querySelectorAll('form[data-nv-add]').forEach(function(f){
      f.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = f.querySelector('[type="submit"]'); var label = btn.innerHTML;
        btn.disabled = true; btn.textContent = T.adding;
        var id = f.querySelector('[name="id"]').value;
        var qEl = f.querySelector('[name="quantity"]');
        var qty = parseInt(qEl ? qEl.value : '1', 10) || 1;
        addItems([{ id: id, quantity: qty }]).then(function(){
          btn.textContent = T.added; replay(btn, 'is-pop'); afterAdd();
        }).catch(function(err){ btn.textContent = err.message || T.err; }).then(function(){
          setTimeout(function(){ btn.disabled = false; btn.innerHTML = label; }, 2200);
        });
      });
    });
  }
  function delegation(){
    document.addEventListener('click', function(e){
      var q = e.target.closest('[data-nv-quick]');
      if (q) {
        e.preventDefault(); e.stopPropagation();
        if (q.disabled) return;
        q.disabled = true; var old = q.innerHTML;
        addItems([{ id: q.getAttribute('data-nv-quick'), quantity: 1 }]).then(function(){
          q.classList.add('is-done'); q.textContent = '✓'; afterAdd();
        }).catch(function(err){ toast(err.message || T.err); }).then(function(){
          setTimeout(function(){ q.disabled = false; q.classList.remove('is-done'); q.innerHTML = old; }, 1600);
        });
        return;
      }
      var dc = e.target.closest('[data-nv-dchange]');
      if (dc) {
        dc.disabled = true;
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(dc.getAttribute('data-line'), 10), quantity: parseInt(dc.getAttribute('data-qty'), 10) }) })
          .then(function(){ if (isCartPage) { window.location.reload(); return; } refreshCount(); return refreshDrawer(); })
          .catch(function(){ dc.disabled = false; toast(T.err); });
        return;
      }
      if (e.target.closest('[data-nv-drawer-close]')) { closeDrawer(); return; }
      var bag = e.target.closest('a.nv-iconbtn--dark');
      if (bag && drawer && !isCartPage) { e.preventDefault(); refreshDrawer().then(openDrawer); }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer(); });
  }
  function qty(){
    document.querySelectorAll('[data-nv-qty]').forEach(function(box){
      var input = box.querySelector('input');
      box.querySelectorAll('button[data-step]').forEach(function(b){
        b.addEventListener('click', function(){
          var v = parseInt(input.value, 10) || 1; v += parseInt(b.getAttribute('data-step'), 10);
          input.value = Math.max(1, Math.min(20, v));
        });
      });
    });
  }
  function gallery(){
    document.querySelectorAll('[data-nv-gallery]').forEach(function(g){
      var main = g.querySelector('[data-nv-main]'); var stage = g.querySelector('[data-nv-stage]');
      g.querySelectorAll('[data-nv-thumb]').forEach(function(t){
        t.addEventListener('click', function(){
          g.querySelectorAll('[data-nv-thumb]').forEach(function(x){ x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
          if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || ''; }
          replay(stage);
        });
      });
      replay(stage);
    });
  }
  function dtabs(){
    document.querySelectorAll('[data-nv-dtabs]').forEach(function(box){
      var btns = box.querySelectorAll('[role="tab"]');
      btns.forEach(function(b){
        b.addEventListener('click', function(){
          btns.forEach(function(x){ x.setAttribute('aria-selected', 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = true; });
          b.setAttribute('aria-selected', 'true');
          var p = document.getElementById(b.getAttribute('aria-controls')); if (p) { p.hidden = false; replay(p, 'nv-swap'); }
        });
      });
    });
  }
  function sticky(){
    var st = document.querySelector('[data-nv-sticky]'); var buy = document.querySelector('[data-nv-buy]');
    if (!st || !buy) return;
    var btn = st.querySelector('[data-nv-sticky-add]'); var on = false;
    function check(){
      var v = buy.getBoundingClientRect().bottom < 0;
      if (v === on) return;
      on = v; st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); btn.tabIndex = on ? 0 : -1;
    }
    window.addEventListener('scroll', check, { passive: true }); window.addEventListener('resize', check); check();
    btn.addEventListener('click', function(){
      var f = document.getElementById('NvBuyForm'); if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type="submit"]').click();
    });
  }
  function reveal(){
    var els = document.querySelectorAll('.nv-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
    els.forEach(function(e){ io.observe(e); });
  }
  function newsletter(){ var f = document.querySelector('[data-nv-news-ok]'); if (f) f.scrollIntoView({ block: 'center' }); }
  function init(){ particles(); puffs(); hero(); forms(); delegation(); qty(); gallery(); dtabs(); sticky(); reveal(); newsletter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();